import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Thanetogoacab() {



    const cardData = {

keyword: "Thane to Goa Cabs",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Thane to Goa Cabs for long-distance travel, family vacations, group tours, honeymoon trips, corporate travel, and one-way or round-trip journeys. We provide a wide range of well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus with professional and experienced chauffeurs. With 24x7 availability, transparent pricing, doorstep pickup across Thane, and safe highway driving via the Mumbai–Goa route, we ensure a smooth, comfortable, and hassle-free journey to Goa.",

topPlaces: [
    {
        title: "Baga Beach",
        description:
            "Baga Beach is one of Goa’s most famous beaches, known for its vibrant nightlife, water sports, beach shacks, and energetic tourist crowd throughout the year."
    },
    {
        title: "Calangute Beach",
        description:
            "Calangute Beach is often called the Queen of Beaches in Goa and is famous for its long coastline, shopping stalls, water sports, and lively tourist atmosphere."
    },
    {
        title: "Anjuna Beach",
        description:
            "Anjuna Beach is known for its rocky shoreline, flea market, sunset views, and relaxed bohemian vibe attracting both domestic and international travelers."
    },
    {
        title: "Fort Aguada",
        description:
            "Fort Aguada is a well-preserved Portuguese fort overlooking the Arabian Sea, famous for its lighthouse, sea views, and historical significance from the colonial era."
    },
    {
        title: "Dudhsagar Waterfalls",
        description:
            "Dudhsagar Waterfalls is one of India’s tallest waterfalls located on the Goa–Karnataka border, surrounded by dense forests and offering breathtaking natural scenery."
    },
    {
        title: "Basilica of Bom Jesus",
        description:
            "Basilica of Bom Jesus is a UNESCO World Heritage Site in Old Goa, known for its baroque architecture and deep religious importance in Christian history."
    },
    {
        title: "Palolem Beach",
        description:
            "Palolem Beach in South Goa is known for its calm waters, scenic beauty, beach huts, and peaceful environment ideal for relaxation and family vacations."
    },
    {
        title: "Chapora Fort",
        description:
            "Chapora Fort is a famous viewpoint overlooking Vagator Beach, known for its sunset views and popularity from Bollywood movies."
    },
    {
        title: "Candolim Beach",
        description:
            "Candolim Beach is a peaceful North Goa beach known for clean shores, water sports, and a relaxed environment away from heavy tourist crowds."
    },
    {
        title: "Se Cathedral",
        description:
            "Se Cathedral is one of the largest churches in Asia, admired for its Portuguese-Gothic architecture and historical importance in Old Goa."
    }
],



services: [
{
name: "Thane to Goa Cabs",
description: "Thane to Goa Cabs service by 1Touch Cabs provides safe, comfortable, and reliable long-distance travel for passengers traveling from Thane to Goa. We offer a wide range of well-maintained vehicles including Sedan, Swift Dzire, Ertiga, Kia Carens, Innova, Innova Crysta, SUV, and Luxury Cars. With professional chauffeurs experienced in highway driving, doorstep pickup, luggage assistance, and 24x7 availability, we ensure a smooth and stress-free journey for families, tourists, and business travelers.",
},
{
name: "Thane to Goa Cab Service",
description: "Thane to Goa Cab Service offers dependable intercity transportation with clean vehicles and trained drivers. 1Touch Cabs ensures safe travel, timely pickup, and comfortable long-distance rides for all types of passengers heading to Goa.",
},
{
name: "Thane to Goa Taxi Service",
description: "Thane to Goa Taxi Service provides convenient and affordable outstation travel with professional chauffeurs and well-maintained AC vehicles. We ensure smooth highway travel and a comfortable journey experience.",
},
{
name: "Thane to Goa Cab Booking",
description: "Thane to Goa Cab Booking service allows easy online reservation with instant confirmation. 1Touch Cabs offers flexible vehicle options, transparent pricing, and 24x7 customer support for hassle-free travel.",
},
{
name: "Thane to Goa One Way Cab",
description: "Thane to Goa One Way Cab service provides budget-friendly long-distance travel without return charges. Ideal for solo travelers, families, and groups looking for affordable and comfortable Goa trips.",
},
{
name: "Thane to Goa Outstation Cab",
description: "Thane to Goa Outstation Cab service is designed for long-distance journeys with safe driving, clean vehicles, and experienced chauffeurs ensuring a comfortable road trip experience.",
},
{
name: "Thane to Goa Innova Cab",
description: "Thane to Goa Innova Cab service offers spacious and comfortable travel for families and groups. Perfect for long highway journeys with extra luggage space and smooth ride comfort.",
},
{
name: "Thane to Goa Innova Crysta Cab",
description: "Thane to Goa Innova Crysta Cab service provides premium comfort with luxury seating, advanced suspension, and professional chauffeurs for a superior travel experience.",
},
{
name: "Thane to Goa Ertiga Cab",
description: "Thane to Goa Ertiga Cab service offers a budget-friendly and comfortable option for families and small groups traveling to Goa with good mileage and spacious seating.",
},
{
name: "Thane to Goa Luxury Cab",
description: "Thane to Goa Luxury Cab service provides premium vehicles with high-end comfort, privacy, and professional chauffeurs for VIP and executive travel to Goa.",
},
{
name: "Thane to Goa AC Taxi Service",
description: "Thane to Goa AC Taxi Service ensures fully air-conditioned, clean, and comfortable vehicles for long-distance travel with safe driving and reliable service.",
},

{
name: "Ghodbunder to Goa Cab Service",
description: "Ghodbunder to Goa Cab Service offers convenient pickup from Ghodbunder Road and surrounding areas with safe and comfortable long-distance travel to Goa.",
},
{
name: "Ghodbunder Road to Goa Cabs",
description: "Ghodbunder Road to Goa Cabs service provides reliable outstation transportation with experienced chauffeurs and multiple vehicle options for families and groups.",
},
{
name: "Ghodbunder to Goa Taxi",
description: "Ghodbunder to Goa Taxi service ensures affordable and comfortable travel with clean vehicles and professional drivers for smooth highway journeys.",
},
{
name: "Ghodbunder to Goa One Way Cab",
description: "Ghodbunder to Goa One Way Cab service provides cost-effective travel without return charges, ideal for one-way trips to Goa.",
},
{
name: "Ghodbunder to Goa Outstation Cab",
description: "Ghodbunder to Goa Outstation Cab service offers safe and reliable long-distance travel with experienced chauffeurs and comfortable vehicles.",
},
{
name: "Ghodbunder to Goa Cab Booking",
description: "Ghodbunder to Goa Cab Booking service enables easy online booking with instant confirmation and flexible vehicle selection.",
},
{
name: "Ghodbunder to Goa Innova Cab",
description: "Ghodbunder to Goa Innova Cab service provides spacious and comfortable travel ideal for families and long-distance journeys.",
},
{
name: "Ghodbunder to Goa Ertiga Cab",
description: "Ghodbunder to Goa Ertiga Cab service offers economical and comfortable transportation for small families and groups.",
},

{
name: "Kalyan Dombivli to Goa Cabs",
description: "Kalyan Dombivli to Goa Cabs service provides safe and reliable long-distance travel with professional chauffeurs and well-maintained vehicles.",
},
{
name: "Kalyan to Goa Cab Service",
description: "Kalyan to Goa Cab Service ensures comfortable outstation travel with multiple vehicle options and 24x7 availability.",
},
{
name: "Dombivli to Goa Taxi Service",
description: "Dombivli to Goa Taxi Service offers dependable intercity transportation with experienced drivers and smooth highway travel.",
},
{
name: "Kalyan to Goa Cab Booking",
description: "Kalyan to Goa Cab Booking service allows quick and easy reservations with transparent pricing and instant confirmation.",
},
{
name: "Dombivli to Goa One Way Cab",
description: "Dombivli to Goa One Way Cab service provides affordable single-trip travel without return fare charges.",
},
{
name: "Kalyan Dombivli to Goa Outstation Cab",
description: "Kalyan Dombivli to Goa Outstation Cab service ensures safe and comfortable long-distance travel for families and groups.",
},
{
name: "Kalyan to Goa Innova Crysta",
description: "Kalyan to Goa Innova Crysta service offers premium comfort, luxury seating, and smooth highway travel for long journeys.",
},
{
name: "Dombivli to Goa Sedan Cab",
description: "Dombivli to Goa Sedan Cab service provides budget-friendly and comfortable travel for individuals and small families.",
},
{
name: "Kalyan to Goa Luxury Taxi",
description: "Kalyan to Goa Luxury Taxi service offers premium vehicles with high comfort and professional chauffeurs for VIP travel.",
},
{
name: "Kalyan Dombivli to Goa AC Cab",
description: "Kalyan Dombivli to Goa AC Cab service ensures fully air-conditioned, clean, and comfortable vehicles for long-distance travel.",
},
{
name: "Bhiwandi to Goa Cabs",
description: "Bhiwandi to Goa Cabs service provides reliable outstation travel with professional drivers, comfortable vehicles, and 24x7 availability for safe Goa trips."
}
],

tableData: [
["Thane to Goa Cabs","Thane to Goa Cab Service"],
["Thane to Goa Taxi Service","Thane to Goa One Way Cab"],
["Thane to Goa Outstation Cab","Thane to Goa Innova Cab"],
["Thane to Goa Ertiga Cab","Thane to Goa Luxury Cab"],
["Ghodbunder to Goa Cab Service","Ghodbunder Road to Goa Cabs"],
["Ghodbunder to Goa Taxi","Ghodbunder to Goa One Way Cab"],
["Ghodbunder to Goa Outstation Cab","Ghodbunder to Goa Cab Booking"],
["Ghodbunder to Goa Innova Cab","Ghodbunder to Goa Ertiga Cab"],
["Kalyan to Goa Cab Service","Dombivli to Goa Taxi Service"],
["Kalyan Dombivli to Goa Outstation Cab","Kalyan to Goa Luxury Taxi"]
],

















whychoose: [
    {
        WhyChooseheading: "Reliable Thane to Goa Cab Service",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable Thane to Goa Cab services for families, couples, tourists, corporate travelers, and vacationers seeking comfortable long-distance transportation."
    },
    {
        WhyChooseheading: "Comfortable Goa Road Trip Experience",
        WhyChoosedescription: "Enjoy a relaxing journey from Thane to Goa through scenic highways, lush landscapes, coastal routes, and beautiful countryside views."
    },
    {
        WhyChooseheading: "Perfect for Holidays and Weekend Getaways",
        WhyChoosedescription: "Whether you are planning a beach holiday, honeymoon, family vacation, friends' trip, or corporate outing, our cab services offer a convenient travel solution."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to passenger count and travel requirements."
    },
    {
        WhyChooseheading: "One-Way and Round Trip Booking Available",
        WhyChoosedescription: "Whether you need a one-way cab, round trip, weekend package, family holiday plan, or customized Goa tour, we provide flexible booking options."
    },
    {
        WhyChooseheading: "Doorstep Pickup Across Thane",
        WhyChoosedescription: "Pickup services are available from Thane West, Thane East, Ghodbunder Road, Majiwada, Kasarvadavali, Wagle Estate, Kalwa, Balkum, Hiranandani Estate, and nearby areas."
    },
    {
        WhyChooseheading: "Experienced Drivers for Long-Distance Travel",
        WhyChoosedescription: "Our professional chauffeurs are experienced on Mumbai-Goa routes and ensure safe driving, route expertise, and a smooth travel experience."
    },
    {
        WhyChooseheading: "Ideal for Families, Couples, and Tourist Groups",
        WhyChoosedescription: "From honeymoon couples and family vacationers to large tourist groups and corporate teams, we provide suitable vehicles for every Goa travel requirement."
    }
]
};

const faqData = [
    {
        question: "Why do travelers book Thane to Goa Cabs?",
        answer: "Goa is famous for its beaches, nightlife, churches, forts, water sports, seafood, and holiday experiences, making it a popular destination for all types of travelers."
    },
    {
        question: "Can I book a one-way cab from Thane to Goa?",
        answer: "Yes, one-way cab services are available along with round-trip and customized Goa holiday packages."
    },
    {
        question: "Which vehicle is suitable for Thane to Goa travel?",
        answer: "Sedan cars, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, and Mini Buses are available according to passenger count and travel preferences."
    },
    {
        question: "Can families book cabs for Goa vacations?",
        answer: "Yes, many families choose our cab services for comfortable travel to Goa resorts, hotels, villas, beaches, and sightseeing destinations."
    },
    {
        question: "Are Tempo Travellers available for group Goa trips?",
        answer: "Yes, Tempo Travellers and Mini Buses are available for family groups, corporate outings, bachelor trips, and tourist groups."
    },
    {
        question: "Can sightseeing places be included during the trip?",
        answer: "Yes, customers can customize their itinerary and visit North Goa, South Goa, beaches, forts, churches, casinos, waterfalls, and other tourist attractions."
    },
    {
        question: "Can pickup be arranged from any Thane location?",
        answer: "Yes, pickup services are available from homes, hotels, offices, railway stations, and all major areas of Thane."
    },
    {
        question: "Do you provide multi-day Goa tour packages?",
        answer: "Yes, customers can book customized Goa holiday packages with flexible travel schedules and sightseeing plans."
    },
    {
        question: "Is advance booking recommended for Thane to Goa travel?",
        answer: "Yes, advance booking is recommended, especially during weekends, long holidays, Christmas, New Year, and peak tourist seasons."
    },
    {
        question: "How can I book a Thane to Goa Cab?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Nitin More",
        feedback:
            "Our family Goa vacation started from Thane and the entire journey was fantastic. The vehicle was comfortable, the driver was professional, and the trip was enjoyable throughout.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Priyanka Shah",
        feedback:
            "We booked a cab from Thane to Goa for a holiday with friends. The vehicle was spacious, clean, and the travel arrangements were handled perfectly from start to finish.",
        rating: 5
    }
];


















   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Thane to Goa Cab Service",
  "image": "https://www.mumbaiairportcabs.com/assets/images/thane-to-goa-cab.jpg",
  "description": "Book Thane to Goa cab service for safe, comfortable, and reliable outstation travel. Mumbai Airport Cabs offers one-way, round-trip, and luxury taxi options including Innova, Innova Crysta, and Ertiga with professional drivers and 24x7 service.",
  "brand": {
    "@type": "Brand",
    "name": "Mumbai Airport Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7800"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹11,999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.mumbaiairportcabs.com/thane-to-goa-cabs"
  }
};





    return (
        <div>

<Helmet>
  <title>Thane to Goa Cabs | Outstation Taxi Service | +91 9545731161</title>

  <meta
    name="description"
    content="Book Thane to Goa cab service for safe and comfortable outstation travel. One way, round trip, and luxury taxi options with professional drivers."
  />

  <meta
    name="keywords"
    content="Thane to Goa Cabs, Thane to Goa Cab Service, Thane to Goa Taxi Service, Thane to Goa Cab Booking, Thane to Goa One Way Cab, Thane to Goa Outstation Cab, Thane to Goa Innova Cab, Thane to Goa Innova Crysta Cab, Thane to Goa Ertiga Cab, Thane to Goa Luxury Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>







            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/6.jpeg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Thanetogoacab;